export enum ShapeType{
    RECT='Rectangle',
    CIRCLE='Circle',
    TRIANGLE='Triangle',
    STAR='Star',
    HEART='Heart',
}